import {decorate, inject, injectable} from '@yosmanyga/di'
import {AbstractSecureStorage, SecureStorage} from '@yosmanyga/abstract-secure-storage'
import {Dispatcher} from "./Dispatcher";

class ConfigManager {
    constructor(
        // TODO: Use localforage
        private storage: SecureStorage,
        private dispatcher: Dispatcher
    ) {
    }

    get = async (
        key: string
    ): Promise<unknown> => {
        return await this.storage.get(key)
    }

    set = async (
        key: string,
        value: string
    ) => {
        await this.storage.set(key, value);

        this.dispatcher.retrieve<(key: string, value: string) => void>('config_set').map(service => service(key, value))
    }

    delete = async (
        key: string
    ) => {
        await this.storage.delete(key)
    }
}

decorate(injectable(), ConfigManager)
decorate(inject(AbstractSecureStorage), ConfigManager, 0)
decorate(inject(Dispatcher), ConfigManager, 1)

export {
    ConfigManager
}
